/* eslint-disable  */
/* eslint-disable no-unused-vars */
/* eslint-disable implicit-arrow-linebreak */
import React, { useEffect, useState } from 'react';
import { SortOrder, TableColumn } from 'react-data-table-component';

import { DefaultTable } from 'src/components';

import { useTypedSelector } from 'src/hooks/useTypedSelector';

import { IBenefitListTable } from 'src/interfaces';

import { useQuery } from '@tanstack/react-query';
import BenefitsService from 'src/services/benefits.service';

import { CustomCell, TooltipBoxTable } from 'src/modules/benefits/components/tooltip-box-table';
import { Container } from './styles';
import { CommonDropdown, ICommonDropdownOption, SearchInput } from 'pg-ui-library';
import { useActions } from 'src/hooks/useActions';
import useDebounce from 'src/hooks/useDebounce';

export const benefitsListInitialColumns: TableColumn<IBenefitListTable>[] = [
  {
    name: 'Benefit Id',
    selector: (row: IBenefitListTable) => row.benefitId || '',
    sortField: 'benefitID',
    width: '180px',
    omit: false,
    sortable: false,
    reorder: true,
    wrap: true,
  },
  {
    name: 'Plan',
    selector: (row: any) => row.plan || '',
    sortField: 'plan',
    width: '180px',
    omit: false,
    sortable: false,
    reorder: true,
    wrap: true,
  },
  {
    name: 'Plan Description',
    selector: (row: IBenefitListTable) => row.planDescription || '',
    width: '180px',
    sortField: 'planDescription',
    omit: false,
    sortable: false,
    reorder: true,
    wrap: true,
  },
  {
    name: 'Option',
    selector: (row: any) => row.option || '',
    width: '180px',
    sortField: 'option',
    omit: false,
    sortable: false,
    reorder: true,
    wrap: true,
  },
  {
    name: 'Option Description',
    selector: (row: IBenefitListTable) => row.optionDescription || '',
    width: '220px',
    sortField: 'optionDescription',
    omit: false,
    sortable: false,
    reorder: true,
    wrap: true,
  },
  {
    name: 'Type',
    selector: (row: IBenefitListTable) => row.type || '',
    width: '180px',
    sortField: 'type',
    omit: false,
    sortable: false,
    reorder: true,
    wrap: true,
  },
  {
    name: 'Rates',
    selector: (row: IBenefitListTable) => row.rates.value,
    cell: ({ rates }: IBenefitListTable) => (
      <CustomCell value={rates.value}>
        <TooltipBoxTable title="Rates" columns={rates.columns} rows={rates.rows} />
      </CustomCell>
    ),
    wrap: true,
  },
];

export const dropdownOptions1 = [
  {
    key: '1',
    label: 'Active benefits',
    value: 'true',
  },
  {
    key: '2',
    label: 'Inactive benefits',
    value: 'false',
  },
];

export const BenefitsListTable: React.FC = () => {
  const [data, setData] = useState<IBenefitListTable[]>([]);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sortBy, setSortBy] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [activeBenefits, setActiveBenefits] = useState(true);
  const personnelNumber = useTypedSelector(state => state.personalInfo.data.personalInfo?.employeeNickId);
  const [benefitStatus, setBenefitStatus] = useState<string>('true');
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const companyId = '';
  const {
    data: benefitsItems,
    refetch,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: ['benefits-deductions'],
    queryFn: () =>
      BenefitsService.getBenefitsDeductions(personnelNumber as unknown as '', {
        page,
        companyId,
        limit,
        search: searchTerm,
        sortBy,
        sortDirection,
        activeBenefits: String(benefitStatus),
      }),
    enabled: true,
  });

  useEffect(() => {
    refetch();
  }, [page, limit, sortBy, sortDirection, benefitStatus, debouncedSearchTerm]);

  useEffect(() => {
    if (benefitsItems) {
      setData(benefitsItems.items);
      setTotalRows(benefitsItems.meta.totalItems);
    }
  }, [benefitsItems]);

  const handlePageChange = (nPage: number) => {
    setPage(nPage);
  };

  const handlePerRowsChange = async (newLimit: number, nPage: number) => {
    setPage(nPage);
    setLimit(newLimit);
  };

  const handleSort = async (column: TableColumn<IBenefitListTable>, newSortDirection: SortOrder) => {
    setSortBy(column.sortField as unknown as string);
    setSortDirection(newSortDirection);
  };

  return (
    <Container>
      <div style={{ display: 'flex', marginTop: '3%', marginLeft: '1%' }}>
        <SearchInput
          value={searchTerm}
          placeholder="Search..."
          handleChange={event => {
            setSearchTerm(event.target.value);
          }}
        />
        <CommonDropdown
          label=""
          id="benefitStatus"
          name="benefitStatus"
          value={benefitStatus as unknown as 0}
          setValue={setBenefitStatus}
          options={dropdownOptions1 as unknown as ICommonDropdownOption[]}
          wrapperStyle={{ width: '10%' }}
          selectStyle={{ maxWidth: 'none', width: '150px', marginRight: '40px', marginLeft: '20px' }}
        />
      </div>
      <div style={{ marginBottom: '510px' }}>
        <DefaultTable
          columns={benefitsListInitialColumns}
          data={data}
          progressPending={isLoading || isFetching}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          onSort={handleSort}
          sortServer
        />
      </div>
    </Container>
  );
};
